import { createAsyncThunk } from "@reduxjs/toolkit";
import NotelClassApi from "api/NotelClassApi";

export const fetchNotelClassByCastNameId = createAsyncThunk(
  "fetchNotelClassByCastNameId",
  ({ companyId, castNameId }: { companyId: number; castNameId: number }) =>
    NotelClassApi.fetchNotelClassByCastNameId(companyId, castNameId)
);
